import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './Pages/Home/Home'
import Contact from './Pages/Contact/Contact'
import Portfolio from './Pages/Portfolio/Portfolio'
import Competences from './Pages/Competences/Competences'
import Error404 from './Pages/Error404/Error404'
import Header from './Components/Header/Header'
import information from './content/information'
import Footer from './Components/footer/Footer'


function App() {
  return (
    <BrowserRouter>
      <Header 
      firstName={information.userData.firstName}
      lastName={information.userData.lastName}
      />
      <Routes>
        <Route path="/" element={<Home img={information.userData.img}
        description={information.userData.description}
        title={information.userData.title}/>} />
        <Route path="/competences" element={<Competences />} />
        <Route path="/portfolio/:monProject?" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}

export default App;
